/* eslint-disable*/
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import KirtanLinePlate from "../pageComponents/KirtanLinePlate";
import PreSettingModal from "../Modals/PreSettingModal";
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import CastIcon from '@mui/icons-material/Cast';
import VideoCameraBackIcon from '@mui/icons-material/VideoCameraBack';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ScreenshotMonitorIcon from '@mui/icons-material/ScreenshotMonitor';
import SettingModal from "../Modals/SettingModal";
import MoveDownIcon from '@mui/icons-material/MoveDown';
import ConfirmBox from "../UserInteractive/ConfirmBox";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ReactSortable } from "react-sortablejs";
import {
  setBookList,
  setKirtanList,
  setContentKirtanList,
} from "../../Slice/formSlice";
import {
  setCurrKirtanIndex,
  setKirtanIndex,
  setSelectedLine,
  setShortcutIndex,
  setSeqId,
  setBookId,
  setDatabaseId,
} from "../../Slice/KirtanIndexSlice";
import {
  setSelectedId,
  setSettingsOpen,
  togglePreSettings,
} from "../../Slice/settingsSlice";
import IndexedDBService, { keyboardSettings, storeName } from "../../Utils/DBConfig";
import CircularProgress from "@mui/material/CircularProgress";
import handleContent from "../../services/kirtanContent.service";
import { setIsSerialConnected } from "../../Slice/keyBoardSlice";

const KirtanArea = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let rxCommand = [];
  let port;
  let writer;
  let textEncoder;
  let writableStreamClosed;

  const selectedLineRef = useRef(null);
  const containerRef = useRef(null); // Ref for the main container

  const [selectedOnZoomButton, setSelectedOnZoomButton] = React.useState([]);

  const [open, setOpen] = useState(false);

  const [multiScreenShotProcess, setMultiScreenShotProcess] = useState(false);

  const [preSettingModalOpen, setPreSettingsModalOpen] = useState(false);

  const [searchModalOpen, setSearchModalOpen] = useState(false);

  const [reloadFlag, setReloadFlag] = useState(false);

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const [loaderEffect, setLoaderEffect] = useState(false);

  const [pageValue, setPageValue] = useState(0);

  const [isLive, setIsLive] = useState(false);

  const [isSource, setIsSource] = useState(false);

  const [isRecord, setIsRecord] = useState(false);

  const [isStream, setIsStream] = useState(false);

  const [padList, setPadList] = useState([]);

  const [favLines, setFavLines] = useState([]);

  const [kirtanData, setKirtanData] = useState({});

  const [lineHistory, setLineHistory] = useState([]);

  const [currLineIndex, setCurrLineIndex] = useState(0);

  const [selectedIndex, setSelectedIndex] = useState(0);

  const [usedShortcut, setUsedShortcut] = useState(null);

  const [hoverKirtanIndex, setHoverKirtanIndex] = useState(null);

  const [hoveredFavLineIndex, setHoveredFavLineIndex] = useState(null);

  const [hoveredRegularLineIndex, setHoveredRegularLineIndex] = useState(null);

  const [isSearchFocused, setIsSearchFocused] = useState(false);

  const [searchBarValue, setSearchBarValue] = useState("");

  const [selectedPlate, setSelectedPlate] = useState(0);

  const [presetId, setPresetId] = useState(null);

  const APIurl = useSelector((state) => state.db.url);

  const selectedLine = useSelector((state) => state.kirtanIndex.selectedLine);

  const isSettingsOpen = useSelector((state) => state.settings.open);

  const kirtanId = useSelector((state) => state.kirtanIndex.kirtanId);

  const seq_id = useSelector((state) => state.kirtanIndex.seq_id);

  const book_id = useSelector((state) => state.kirtanIndex.book_id);

  const database_id = useSelector((state) => state.kirtanIndex.database_id);

  const bookList = useSelector((state) => state.FormList.book_list);

  const kirtanLineId = useSelector((state) => state.kirtanIndex.currIndex);

  const isDbInitialized = useSelector((state) => state.db.isDbInitialized);

  const isDualLineMode = useSelector((state) => state.settings.isDualLineMode);

  const searchFlag = useSelector((state) => state.kirtanIndex.searchFlag);

  const sourceMode = useSelector((state) => state.vMixButton.sourceMode);

  const recordMode = useSelector((state) => state.vMixButton.recordMode);

  const streamMode = useSelector((state) => state.vMixButton.streamMode);

  const isPreSettingsOpen = useSelector((state) => state.settings.preSettingsOpen);

  const kirtanList = useSelector((state) => state.FormList.kirtan_list);

  const content_kirtan_list = useSelector((state) => state.FormList.content_kirtan_list);

  const vMixApi = useSelector((state) => state.vMixButton.vMixApi);

  const mixerApi = useSelector((state) => state.vMixButton.mixerApi);

  // pre setting data
  const preSettings = useSelector((state) => state.settings.preSettings);
  const selectedId = useSelector((state) => state.settings.selectedId);

  const isSerialConnected = useSelector((state) => state.keyboardSlice.isSerialConnected);

  const vMixZoomButton = useSelector((state) => state.vMixZoomButton.VMixZoomButton);

  const textFieldStyles = {
    borderRadius: "999px",
    width: isSearchFocused || searchBarValue ? "500px" : "200px", // Width changes based on focus or if there is a value
    height: "26px", // Set the height similar to the modified switch component
    transition: "width 0.3s", // Smooth transition for width change
    backgroundColor: "#FFFFFF",
    "&.Mui-focused": {
      backgroundColor: "#FFFFFF", // Keep the background color on focus if needed
    },
  };

  const inputProp = {
    style: {
      borderRadius: "999px",
      height: "26px", // Reduced input height to match compact design
      padding: '4px', // Optional: Adjust padding to center text vertically if necessary
    },
  };

  const handleRegularLineHover = (index) => setHoveredRegularLineIndex(index);

  const handleFavLineHover = (index) => setHoveredFavLineIndex(index);

  const handleShowDeleteConfirm = (x) => setShowDeleteConfirm(x);

  const handleFocus = () => {
    setIsSearchFocused(true);
  };

  const timeOut = (timeDuration = 1000) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        setIsSearchFocused(false);
      }, timeDuration);
    });
  };

  const handleBlur = (event) => {
    timeOut(1400);
  };

  const handleChangeSearchBarValue = (event) => {
    setSearchBarValue(event.target.value);
    setPageValue(0);
  };

  const masterData = async () => {
    return new Promise(async (resolve, reject) => {
      const url = `${APIurl}/api/kirtan/masterData-list`;
      const res = await fetch(url);
      const jsonData = await res.json();
      const dataList = await jsonData.data;
      dispatch(setBookList(dataList.book_list));
      resolve(true);
    });
  };

  const handleSeqFetchData = async (data, tab) => {
    const finalContent = handleContent(data.content);
    setReloadFlag(!reloadFlag);
    const dbData = {
      id: tab
        ? Number(kirtanId)
        : kirtanData.length > 0
          ? kirtanData[kirtanData.length - 1]?.id + 1
          : 0,
      title: data.unicode_title,
      content: finalContent,
      shortcuts: {
        0: "1",
        1: "2",
        2: "3",
        3: "4",
        4: "5",
        5: "6",
        6: "7",
        7: "8",
        8: "9",
      },
      seq_id: data.seq_id || 0,
      book_id: data.book_id || 0,
      database_id: data.id || 0,
      originalContent: data.content,
      settings: {
        fontSize: "50px",
        fontWeight: "500",
        color: "#ffffff",
        backgroundColor: "#000000",
        height: "100px",
        textShadowColor: "#ffffff",
        textShadowWidth: "0px",
        isDualLineMode: false,
      },
      favLines: [0, 1],
      lineHistory: [],
      selectedLine: 0,
      selectedPlate: 1,
      selectedPlate: 1,
    };

    if (isDbInitialized) {
      if (tab) {
        IndexedDBService.updateItem(dbData, storeName)
          .then(() => {
            dispatch(setKirtanIndex(dbData.id));
            setReloadFlag(!reloadFlag);
            dispatch(setCurrKirtanIndex(0));
            setCurrLineIndex(0);
          })
          .then(() => {
            timeOut(1400);
          });
      } else {
        IndexedDBService.addItem(dbData, storeName)
          .then(() => {
            dispatch(setKirtanIndex(dbData.id));
            setReloadFlag(!reloadFlag);
            dispatch(setCurrKirtanIndex(0));
            setCurrLineIndex(0);
          })
          .then(() => {
            timeOut(1400);
          })
          .catch((error) => console.error(error));
      }
    }
  };

  const handlePrevious = async () => {
    let queryString = `?book_id=${book_id}&seq_id=${seq_id - 1}&page=${0}&limit=${50}`;
    try {
      const url = `${APIurl}/api/kirtan/filterList${queryString}`;
      const res = await fetch(url);
      const jsonData = await res.json();
      const dataList = jsonData.data;
      const dataObj = dataList[0];
      if (dataObj) handleSeqFetchData(dataObj, true);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePadClick = async (id) => {
    try {
      if (id === 0) return;
      const url = `${APIurl}/api/kirtan/id/${id}`;
      const res = await fetch(url);
      const jsonData = await res.json();
      const kirtanById = jsonData.data;
      if (kirtanById) handleSeqFetchData(kirtanById, true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFilterChange = async () => {
    try {
      let queryString = `?search=${searchBarValue}&page=${pageValue}`;
      const url = `${APIurl}/api/kirtan/search${queryString}`;
      const res = await fetch(url);
      const jsonData = await res.json();
      const dataList = jsonData.data;
      if (pageValue === 0) {
        dispatch(setKirtanList(dataList.find_kirtan_by_title));
        dispatch(setContentKirtanList(dataList.find_kirtan_by_content));
      } else {
        dispatch(
          setKirtanList([...kirtanList, ...dataList.find_kirtan_by_title])
        );
        dispatch(
          setContentKirtanList([
            ...content_kirtan_list,
            ...dataList.find_kirtan_by_content,
          ])
        );
      }
      setLoaderEffect(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleNext = async () => {
    let queryString = `?book_id=${book_id}&seq_id=${seq_id + 1
      }&page=${0}&limit=${50}`;
    try {
      const url = `${APIurl}/api/kirtan/filterList${queryString}`;
      const res = await fetch(url);
      const jsonData = await res.json();
      const dataList = jsonData.data;
      const dataObj = dataList[0];
      if (dataObj) handleSeqFetchData(dataObj, true);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchKirtanPadList = async () => {
    try {
      const url = `${APIurl}/api/kirtan/pad-list/${database_id}`;
      const res = await fetch(url);
      const jsonData = await res.json();
      const padList = await jsonData.data;
      setPadList(padList);
    } catch (error) {
      console.log(error);
    }
  };

  const handleModalToggle = (value) => {
    dispatch(setSettingsOpen(value));
    setOpen(value);
  };

  const handlePreSettingModalToggle = (value) => {
    setPreSettingsModalOpen(value);
    dispatch(togglePreSettings(value));
    if (!value) {
      setPresetId(null);
    }
  };

  const handleCurrLineIndex = (index) => {
    setCurrLineIndex(index);
    dispatch(setCurrKirtanIndex(index));

    let kirtanData = { ...getKirtanById() };
    kirtanData.selectedLine = index;
    if (isDbInitialized) {
      IndexedDBService.updateItem(kirtanData, storeName)
        .then(() => { })
        .catch((error) => console.error(error));
    }
  };

  const handleChange = async (x) => {
    const res = await handleVMixInput(x);
    res && setIsLive(x);
    res && localStorage.setItem("isLive", JSON.stringify(x));
  };

  const handleScreenShotClick = async (flag) => {
    let vmixSettings = localStorage.getItem("vmixSettings");
    let multiScreenShotProcessFlag = flag || multiScreenShotProcess;
    // if (vmixSettings && multiScreenShotProcessFlag) {
    if (vmixSettings) {
      vmixSettings = JSON.parse(vmixSettings);
      const d = new Date;
      const currentTime = `${d.getHours()}_${d.getMinutes()}_${d.getSeconds()}_${d.getMilliseconds()}`;
      let url = `${vmixSettings.webControllerUrl}/api/?Function=SnapshotInput&Input=ICG&Value=mysnapshot%20%7B0:dd%20MMM%20yyyy%7D%20${currentTime}.png`;
      try {
        const response = await fetch(url, {
          method: 'GET',
        });
        if (response.ok) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    }
  };

  const handleMultiScreenShot = async () => {
    if (multiScreenShotProcess) {
      setMultiScreenShotProcess(false); // Toggle off to stop if already in process
    } else {
      setMultiScreenShotProcess(true);
      const res = await handleMultiScreenShotClick();
      res && setMultiScreenShotProcess(false); // Set process to false when finished
    }
  };

  const handleMultiScreenShotClick = async () => {
    for (let index = currLineIndex; index < getKirtanById().content.length; index++) {
      // Stop the process if multiScreenShotProcess is set to false
      // if (!multiScreenShotProcess) {
      //   return false; // Exit the function early
      // }

      setCurrLineIndex(index);
      dispatch(setCurrKirtanIndex(index));
      await handleScreenShotClick();

      // Add a delay of one second
      await new Promise(resolve => setTimeout(resolve, 1000));
    }

    return true; // Indicate process completed successfully
  };

  const handleMixerApi = async (flag) => {
    try {
      // console.log('api', `http://127.0.0.1:8000/press/bank/1/31`);
      // const response = await fetch("http://127.0.0.1:8000/press/bank/1/31", { mode: "no-cors" });
      console.log('api', `http://127.0.0.1:8000/api/location/5/1/1/press`);
      const response = await fetch("http://127.0.0.1:8000/api/location/5/1/1/press", {
        method: "POST",
      });
      setIsLive(flag);
    } catch (error) {
      console.log('error: ', error);
    }
  };

  // const handleMixerApi = async () => {
  //   try {
  //     const apiUrl = `http://127.0.0.1:8000/api/location/5/1/4/press`;
  //     console.log('api', apiUrl);

  //     const response = await fetch(apiUrl, {
  //       method: 'POST',
  //     });

  //     if (response.status === 200) {
  //       const data = await response.json();
  //       console.log('Success:', data);
  //     } else {
  //       console.log('Unexpected response status:', response.status);
  //       const errorData = await response.json();
  //       console.log('Response data:', errorData);
  //     }
  //   } catch (error) {
  //     console.error('Error:', error);
  //   }
  // };


  const handleVMixInput = async (flag) => {
    let vmixSettings = JSON.parse(localStorage.getItem("vmixSettings"));

    console.log('in handleVMixInput: ');
    if (vmixSettings && mixerApi) handleMixerApi(flag);

    if (vmixSettings && vMixApi) {
      if (
        vmixSettings.webControllerUrl === "" ||
        vmixSettings.overlayChannelId === "" ||
        vmixSettings.inputId === "" || vmixSettings.twoLineInputId === ""
      )
        return false;

      let func = "OverlayInput";
      if (flag) func = func + vmixSettings.overlayChannelId + "In";
      else func = func + vmixSettings.overlayChannelId + "Out";

      // if (flag) {
      //   func += isDualLineMode ? vmixSettings.twoLineInputId : vmixSettings.inputId + "In";
      // } else {
      //   func += vmixSettings.overlayChannelId + "Out";
      // }

      let url = `${vmixSettings.webControllerUrl}/api/?Function=${func}&input=${vmixSettings.inputId}`;
      try {
        await fetch(url, { mode: "no-cors" });
        return true;
      } catch (e) {
        console.log('e: ', e);
        return false;
      }
    }
  };

  const handleVMixSource = async () => {
    let vmixSettings = localStorage.getItem("vmixSettings");

    if (vmixSettings) {
      vmixSettings = JSON.parse(vmixSettings);
      if (vmixSettings.webControllerUrl === "") return false;

      let url = `${vmixSettings.webControllerUrl}/api/?Function=OverlayInput1&input=Source`;
      try {
        await fetch(url, { mode: "no-cors" });
        return true;
      } catch (e) {
        console.log('e: ', e);
        return false;
      }
    }
  };

  const handleTabPress = async () => {
    const flag = !isSource;
    try {
      const res = await handleVMixSource();
      if (res) {
        setIsSource(flag);
      }
    } catch (error) {
      console.error('Error in handleVMixSource:', error);
    }
  };

  // const handleTabPress = async () => {
  //   const flag = !isSource;
  //   const res = await handleVMixSource();
  //   if (res) setIsSource(flag);
  // };

  // const handleSourceClick = () => {
  //   const res = handleVMixSource(!isSource);
  //   res && setIsSource(res);
  // };

  // Line History
  const handleLineHistory = (line) => {
    let history = lineHistory.length > 0 ? [...lineHistory] : [];

    const existingIndex = history.indexOf(line);

    if (existingIndex !== -1) {
      history.splice(existingIndex, 1);
    }

    if (history.length > 9) history.shift();

    history.push(line);

    let kirtanData = { ...getKirtanById() };
    kirtanData.lineHistory = history;

    setLineHistory(history);

    if (isDbInitialized) {
      IndexedDBService.updateItem(kirtanData, storeName)
        .then(() => { })
        .catch((error) => console.error(error));
    }
  };

  // Favrorite Lines
  const handleFavLines = (id) => {
    let favoriteLines = favLines.length > 0 ? [...favLines] : [];

    if (favoriteLines.includes(id))
      favoriteLines = favLines.filter((lineId) => lineId !== id);
    else favoriteLines = [...favLines, id];

    setFavLines(favoriteLines);

    let currKirtanData = { ...getKirtanById() };
    currKirtanData.favLines = favoriteLines;

    isDbInitialized &&
      IndexedDBService.updateItem(currKirtanData, storeName)
        .then(() => { })
        .catch((error) => console.error(error));
  };

  // Get Kirtan By Id
  const getKirtanById = () => {
    return (
      kirtanData.length > 0 &&
      kirtanData.find((kirtan) => kirtan.id === kirtanId)
    );
  };

  const findBookName = (id) => {
    const book = bookList?.find((book) => book.id === id);
    return book ? book.name : null;
  };

  const findBookShortName = (id) => {
    const book = bookList?.find((book) => book.id === id);
    return book ? book.short_code : null;
  };

  const handlePreSettingModal = (id) => {
    handlePreSettingModalToggle(true);
    setPresetId(id);
  };

  const getUpdatedList = (data) => {
    const filteredIds = data.map((ele) => {
      delete ele.chosen;
      return Number(ele);
    });

    setFavLines(filteredIds);
    let currKirtanData = { ...getKirtanById() };
    currKirtanData.favLines = filteredIds;

    isDbInitialized &&
      IndexedDBService.updateItem(currKirtanData, storeName)
        .then(() => { })
        .catch((error) => console.error(error));
  };

  const handleClearHistory = () => {
    setLineHistory([]);
    let kirtanData = { ...getKirtanById() };
    kirtanData.lineHistory = [];
    isDbInitialized &&
      IndexedDBService.updateItem(kirtanData, storeName)
        .then(() => { })
        .catch((error) => console.error(error));
  };

  const handleHistorySwitch = (isForward) => {
    const index = lineHistory.findIndex((line) => line === currLineIndex);

    if (index === -1) return;

    const nextLine = lineHistory[isForward ? index + 1 : index - 1];

    if (nextLine === undefined) return;
    handleCurrLineIndex(nextLine);
  };

  const handleKey = async (event) => {
    let flag = localStorage.getItem("isLive") === "true" ? true : false;
    if (!isSettingsOpen) {
      if (event.key === "Escape") flag = false;
      // else if (event.key === "Enter") flag = true;
      else if (event.key === " ") flag = !flag;
      else event.preventDefault();

      const res = await handleVMixInput(flag);

      localStorage.setItem("isLive", JSON.stringify(flag));

      res && setIsLive(flag);
    }
  };

  //handle search modal
  const handleSearchModalToggle = (value) => {
    dispatch(setSettingsOpen(value));
    setSearchModalOpen(value);
  };

  //handle delete
  const handleDelete = () => {
    isDbInitialized &&
      IndexedDBService.deleteItem(Number(kirtanId))
        .then(() => {
          IndexedDBService.getAllData(storeName).then((data) => {
            dispatch(setKirtanIndex(data[0]?.id || 0));
            navigate("/");
          });
        })
        .catch((error) => console.error(error));
    handleShowDeleteConfirm(false);
  };

  // Pre Setting
  const handlePreSettingApply = (id) => {
    setSelectedPlate(id);
    let kirtanData = { ...getKirtanById() };
    kirtanData.selectedPlate = id;
    if (isDbInitialized) {
      IndexedDBService.updateItem(kirtanData, storeName)
        .then(() => { })
        .catch((error) => console.error(error));
    }
  };

  const handleTitleScroll = () => {
    const box = document.getElementById("title-box");
    if (box.scrollTop + box.clientHeight >= box.scrollHeight && !loaderEffect) {
      setPageValue((pres) => pres + 1);
      setLoaderEffect(true);
    }
  };

  const handleContentScroll = () => {
    const box = document.getElementById("content-box");
    if (box.scrollTop + box.clientHeight >= box.scrollHeight && !loaderEffect) {
      setPageValue((pres) => pres + 1);
      setLoaderEffect(true);
    }
  };

  const handleVMixButtons = async (name) => {
    let vmixSettings = localStorage.getItem("vmixSettings");

    if (vmixSettings) {
      vmixSettings = JSON.parse(vmixSettings);
      if (vmixSettings.webControllerUrl === "") return false;
      let url = `${vmixSettings.webControllerUrl}/api/?Function=${name}`;
      try {
        await fetch(url, { mode: "no-cors" });
        toast.success(url);
        switch (name) {
          case "StartRecording" || "StopRecording":
            setIsRecord(flag);
            break;
          case "StartStreaming" || "StopStreaming":
            setIsStream(flag);
            break;
          default:
        }
        return true;
      } catch (e) {
        toast.error(url);
        console.log('e: ', e);
        return false;
      }
    }
  };

  const handleVMixButtonsClick = (buttonName) => {
    switch (buttonName) {
      case "record":
        handleVMixButtons(!isRecord, !isRecord ? "StartRecording" : "StopRecording");
        break;
      case "stream":
        handleVMixButtons(!isStream, !isStream ? "StartStreaming" : "StopStreaming");
        break;
      case "sourceOverlay":
        handleTabPress();
        break;
      default:
        break;
    }
  };

  // serial port functions 
  const handleConnectClick = () => {
    if (navigator.serial) {
      connectSerialPort();
    } else {
      alert("Web Serial API not supported.");
    }
  };

  const connectSerialPort = async () => {
    try {
      // Prompt user to select any serial port.
      port = await navigator.serial.requestPort();
      await port.open({ baudRate: 115200 });

      textEncoder = new TextEncoderStream();
      writableStreamClosed = textEncoder.readable.pipeTo(port.writable);

      writer = textEncoder.writable.getWriter();
      dispatch(setIsSerialConnected(true));
      listenToPort();
    } catch (error) {
      console.log('error: ', error);
      // port.close();
      dispatch(setIsSerialConnected(false));
    }
  };

  const listenToPort = async () => {
    const textDecoder = new TextDecoderStream();
    const readableStreamClosed = port.readable.pipeTo(textDecoder.writable);
    const reader = textDecoder.readable.getReader();
    // Listen to data coming from the serial device.
    while (true) {
      const { value, done } = await reader.read();
      if (done) {
        // Allow the serial port to be closed later.
        reader.releaseLock();
        break;
      }
      // value is a string.
      appendToTerminal(value);
      // extractAndRemoveNumbers(value);
    }
  };

  const extractAndRemoveNumbers = async (buffer) => {
    // Regular expression to find a pattern like ":123:" where 123 can be any number
    const regex = /:(\d+):/g;
    let match;
    let updatedBuffer = buffer;
    const numbers = [];

    // Loop through all matches in the string
    while ((match = regex.exec(buffer)) !== null) {
      // Convert the captured number to an integer and add to the list
      numbers.push((match[1], 10));

      // Remove the first occurrence of the matched pattern
      updatedBuffer = updatedBuffer.replace(`:${match[1]}:`, "");
    }

    return {
      numbers,
      updatedBuffer,
    };
  };

  const appendToTerminal = async (newStuff) => {
    rxCommand = rxCommand + newStuff;

    const result = await extractAndRemoveNumbers(rxCommand);
    if (result.numbers.length > 0) {
      const data = await IndexedDBService.getAllData(keyboardSettings);
      let arr = result.numbers;
      if (arr) {
        for (let index = 0; index < arr.length; index++) {
          const button = data.find((key) => key.id === +arr[index]);
          if (button) {
            processApiCalls(button);
          }
        }
      }
    } else {
    }
    rxCommand = result.updatedBuffer;
  };

  const processApiCalls = (data) => {
    // Process GET APIs
    ['get1', 'get2', 'get3'].forEach(field => {
      if (data[field].flag) {
        axios.get(data[field].api)
          .then(response => {
            console.log(`GET ${field} response:`, response.data);
          })
          .catch(error => {
            console.error(`GET ${field} error:`, error);
          });
      }
    });

    // Process POST APIs
    ['post1', 'post2'].forEach(field => {
      if (data[field].flag) {
        axios.post(data[field].api)
          .then(response => {
            console.log(`POST ${field} response:`, response.data);
          })
          .catch(error => {
            console.error(`POST ${field} error:`, error);
          });
      }
    });
  };

  const handleApiCall = async (id) => {
    const selectedButton = vMixZoomButton.find((button) => button.id === +id);
    let vmixSettings = localStorage.getItem("vmixSettings");
    if (vmixSettings) {
      vmixSettings = JSON.parse(vmixSettings);
      let url = `${vmixSettings.webControllerUrl}/${selectedButton.api}`;
      try {
        await fetch(url, { mode: "no-cors" });
        return true;
      } catch (e) {
        return false;
      }
    } else {
      return false;
    }
  };

  const handleZoomCLick = async (id) => {
    const apiResponse = await handleApiCall(id);
    if (apiResponse) {
      if (id >= 1 && id <= 6) {
        // Logic for IDs between 1 and 6: replace previous values 1 to 6 with the new ID
        setSelectedOnZoomButton(prevSelected => [
          ...prevSelected.filter(value => value < 1 || value > 6),
          id
        ]);
      } else {
        // For other IDs: toggle the ID in the list (add if not present, remove if present)
        setSelectedOnZoomButton(prevSelected =>
          prevSelected.includes(id)
            ? prevSelected.filter(value => value !== id) // Remove if already present
            : [...prevSelected, id] // Add if not present
        );
      }
    }
  };

  useEffect(() => {
    handleFilterChange();
    masterData();
    const body = document.querySelector("body");

    body.style.overflow = "hidden";

    return () => (body.style.overflow = "auto");
  }, []);

  useEffect(() => {
    if (containerRef.current && selectedLineRef.current) {
      const containerTop = containerRef.current.getBoundingClientRect().top;
      const selectedTop = selectedLineRef.current.getBoundingClientRect().top;
      const offset = selectedTop - containerTop - containerRef.current.clientHeight / 2;
      containerRef.current.scrollTo({ top: containerRef.current.scrollTop + offset, behavior: "smooth" });
    }
  }, [selectedLine]);

  useEffect(() => {
    if (kirtanId && kirtanId != selectedIndex) {
      setSelectedIndex(Number(kirtanId));
    }
  }, [kirtanId]);

  useEffect(() => {
    handleFilterChange();
  }, [pageValue]);

  useEffect(() => {
    if (kirtanLineId) handleCurrLineIndex(kirtanLineId);
  }, [kirtanLineId]);

  useEffect(() => {
    fetchKirtanPadList();
  }, [database_id]);

  useEffect(() => {
    handleFilterChange();
  }, [searchBarValue, isSearchFocused]);

  useEffect(() => {
    let SqeID = getKirtanById()?.seq_id || 0;
    dispatch(setSeqId(SqeID));
    let BookID = getKirtanById()?.book_id || 0;
    dispatch(setBookId(BookID));
    let databaseId = getKirtanById()?.database_id || 0;
    dispatch(setDatabaseId(databaseId));
  }, [kirtanData, reloadFlag, selectedIndex]);

  useEffect(() => {
    if (selectedIndex) {
      let index = getKirtanById()?.selectedLine || 0;
      handleCurrLineIndex(index);
    }
  }, [selectedIndex]);

  useEffect(() => {
    isDbInitialized &&
      IndexedDBService.getData(Number(selectedIndex), storeName)
        .then((data) => {
          dispatch(setSelectedId(data.selectedPlate));
        })
        .catch((error) => console.error(error));
  }, [isDbInitialized, selectedPlate, selectedIndex]);

  useEffect(() => {
    isDbInitialized &&
      IndexedDBService.getData(Number(selectedIndex), storeName).then(
        (data) => {
          setFavLines(data.favLines);
          setLineHistory(data.lineHistory);
          dispatch(setSelectedLine(data.selectedLine));
        }
      );
    // dispatch(setDatabaseId(getKirtanById()?.database_id || 0));
  }, [selectedIndex, isDbInitialized, currLineIndex, reloadFlag]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      // Check if the event target is an input field or textarea
      const targetTagName = event.target.tagName.toLowerCase();
      if (targetTagName === "input" || targetTagName === "textarea") {
        // If yes, do nothing and return early
        return;
      }

      event.preventDefault();
      if (!isSettingsOpen) {
        const isShortcutPressed = !isNaN(Number(event.key));

        if (
          isShortcutPressed &&
          event.key !== " " &&
          favLines.length >= Number(event.key)
        ) {
          setUsedShortcut(Number(event.key));
          dispatch(setShortcutIndex(favLines[Number(event.key) - 1]));
        }

        if (
          event.key === "Escape" ||
          event.key === "Enter" ||
          event.key === " "
        ) {
          handleKey(event);
        }

        // if (event.key === "Tab") {
        //   handleVMixButtonsClick("sourceOverlay");
        // }

        // if (event.key === "Control") {
        //   handleVMixButtonsClick("sourceOverlay");
        // }

        switch (event.key) {
          case "Delete":
            handleShowDeleteConfirm(true);
            break;
          case "ArrowUp":
            if (currLineIndex > 0) {
              handleLineHistory(currLineIndex);
              handleCurrLineIndex(currLineIndex - 1);
              setUsedShortcut(null);
              dispatch(setShortcutIndex(null));
            }
            break;
          case "ArrowDown":
            if (currLineIndex < getKirtanById()?.content?.length - 1) {
              handleLineHistory(currLineIndex);
              handleCurrLineIndex(currLineIndex + 1);
              setUsedShortcut(null);
              dispatch(setShortcutIndex(null));
            }
            break;

          case "ArrowLeft":
            handleHistorySwitch(false);
            setUsedShortcut(null);
            dispatch(setShortcutIndex(null));
            break;

          case "ArrowRight":
            handleHistorySwitch(true);
            setUsedShortcut(null);
            dispatch(setShortcutIndex(null));
            break;

          case "q":
            handleClearHistory();
            break;

          case " ":
            break;

          case "F11":
            {
              const docElm = document.documentElement;
              const isFullScreen =
                document.fullscreenElement ||
                document.mozFullScreenElement ||
                document.webkitFullscreenElement ||
                document.msFullscreenElement;

              if (!isFullScreen) {
                // Enter fullscreen
                if (docElm.requestFullscreen) {
                  docElm.requestFullscreen();
                } else if (docElm.mozRequestFullScreen) {
                  docElm.mozRequestFullScreen();
                } else if (docElm.webkitRequestFullscreen) {
                  docElm.webkitRequestFullscreen();
                } else if (docElm.msRequestFullscreen) {
                  docElm.msRequestFullscreen();
                }
              } else {
                // Exit fullscreen
                if (document.exitFullscreen) {
                  document.exitFullscreen();
                } else if (document.mozCancelFullScreen) {
                  document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                  document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                  document.msExitFullscreen();
                }
              }
            }
            break;

          default:
            break;
        }
      }
    };

    !isSettingsOpen &&
      !isPreSettingsOpen &&
      window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [favLines, isSettingsOpen, currLineIndex, isPreSettingsOpen]);

  useEffect(() => {
    isDbInitialized &&
      IndexedDBService.getAllData(storeName).then((data) =>
        setKirtanData(data)
      );
  }, [isDbInitialized, selectedIndex, currLineIndex, kirtanLineId, favLines, searchFlag, showDeleteConfirm, reloadFlag]);

  return (
    <div
      className="py-1 flex flex-col justify-between bg-[#ffffff] w-full lineBackground relative"
      style={{
        height: "calc(100vh)",
      }}
    >
      <Box className="flex flex-col w-full justify-center items-center">
        <Box className="flex w-full justify-between px-3">
          <Box className="flex w-full overflow-x-auto overflow-y-hidden items-center gap-3">
            <Box className="flex justify-start items-center gap-2 h-max-[26px]">
              {Object.keys(kirtanData).map((key, index) => {
                const id = kirtanData[key].id;
                return (
                  <Box
                    key={index}
                    style={{
                      backgroundColor:
                        selectedIndex == id ? "#2196f3" : "#ffffff",
                      color: selectedIndex == id ? "#ffffff" : "#000000",
                    }}
                    onMouseEnter={() => setHoverKirtanIndex(id)}
                    onMouseLeave={() => setHoverKirtanIndex(null)}
                    className="kirtanTitle gap-2 flex justify-center items-center text-xl cursor-pointer px-2 rounded-full shadow-md select-none font-medium h-6"
                    onClick={() => {
                      setSelectedIndex(id);
                      dispatch(setKirtanIndex(id));
                    }}
                    onDoubleClick={(e) => {
                      e.stopPropagation();
                      dispatch(setKirtanIndex(id));
                      navigate(`/edit/${id}`);
                    }}
                  >
                    <p className="text-center text-xs text-wrap">
                      {kirtanData[key].title.length > 12
                        ? `${kirtanData[key].title.slice(0, 12)}...`
                        : kirtanData[key].title}
                    </p>
                    <Box
                      className={`cross text-base ${hoverKirtanIndex === id ? "opacity-100" : "opacity-0"
                        } duration-300 ease-in-out transition-all text-center hidden`}
                      onClick={() => handleShowDeleteConfirm(true)}
                    >
                      <i
                        className={
                          `fa-solid fa-xmark fa-lg  text-center` +
                          `${selectedIndex == id ? "text-white" : "text-black"}`
                        }
                      ></i>
                    </Box>
                  </Box>
                );
              })}
            </Box>
            <Tooltip title="Add New" arrow>
              <Box
                className="text-xl hover:bg-gray-300 h-7 w-7 flex items-center justify-center rounded-full duration-300 ease-in-out transition-all cursor-pointer bg-white shadow-md"
                onClick={() => {
                  navigate("/input");
                }}
              >
                <i className="fa-solid fa-plus fa-sm"></i>
              </Box>
            </Tooltip>
          </Box>
          <Box className="flex justify-center items-center gap-3">
            <TextField
              className="w-100px"
              sx={textFieldStyles}
              size="small"
              placeholder="search..."
              value={searchBarValue}
              onChange={handleChangeSearchBarValue}
              onFocus={handleFocus}
              onBlur={handleBlur}
              id="Kirtan_Title_Sulekh"
              autoComplete="off"
              InputProps={inputProp}
            />
            {isSearchFocused && (
              <Tooltip title="Master-Search" arrow>
                <Box
                  className={`flex items-center justify-center cursor-pointer hover:bg-gray-300 p-2 h-7 w-7 rounded-full duration-300 ease-in-out transition-all bg-white shadow-md`}
                  onClick={() => {
                    navigate("/search", { state: { oldLocation: "main" } });
                  }}
                  aria-label="open drawer"
                >
                  <i className="fa-solid fa-sliders fa-sm"></i>
                </Box>
              </Tooltip>
            )}
            {/* <SwitchComp
              checked={isLive}
              handleChange={handleChange}
              name={"isLive"}
            /> */}
            <Tooltip title="keyboard" arrow>
              <Box
                className={`flex items-center justify-center cursor-pointer hover:bg-gray-300 p-2 h-7 w-7 rounded-full duration-300 ease-in-out transition-all ${isSerialConnected ? 'bg-[#D89F64]' : 'bg-white'} shadow-md`}
                onClick={handleConnectClick}
                aria-label="open drawer"
              >
                <i class="fa-brands fa-usb"></i>
                {/* <KeyboardIcon fontSize="small" /> */}
              </Box>
            </Tooltip>
            <Tooltip title="Converter" arrow>
              <Box
                className={`flex items-center justify-center cursor-pointer hover:bg-gray-300 p-2 h-7 w-7 rounded-full duration-300 ease-in-out transition-all bg-white shadow-md`}
                onClick={() => {
                  navigate("/converter");
                }}
                aria-label="open drawer"
              >
                <MoveDownIcon fontSize="small" />
              </Box>
            </Tooltip>
            <Tooltip title="Form" arrow>
              <Box
                className={`flex items-center justify-center cursor-pointer hover:bg-gray-300 p-2 h-7 w-7 rounded-full duration-300 ease-in-out transition-all bg-white shadow-md`}
                onClick={() => {
                  navigate("/kirtan-data");
                }}
                aria-label="open drawer"
              >
                <i className="fa-solid fa-file-export fa-sm"></i>
              </Box>
            </Tooltip>
            <Tooltip title="V-mix Setting" arrow>
              <Box
                className={`flex items-center justify-center cursor-pointer hover:bg-gray-300 p-2 h-7 w-7 rounded-full duration-300 ease-in-out transition-all bg-white shadow-md`}
                onClick={() => {
                  handleModalToggle(true);
                }}
                aria-label="open drawer"
              >
                <i className="fa-solid fa-gear fa-sm"></i>
              </Box>
            </Tooltip>
          </Box>
          {preSettingModalOpen && (
            <PreSettingModal
              open={preSettingModalOpen}
              handlePreSettingModal={handlePreSettingModalToggle}
              id={presetId}
            />
          )}
          {/* <Suspense fallback={<h1>Still Loading…</h1>}>
            {searchModalOpen && <SearchModal searchModalOpen={searchModalOpen} handleSearchModalToggle={handleSearchModalToggle} />}
          </Suspense> */}
          {searchModalOpen && (
            <SearchModal
              searchModalOpen={searchModalOpen}
              handleSearchModalToggle={handleSearchModalToggle}
            />
          )}

          <SettingModal open={open} handleModalToggle={handleModalToggle} />
        </Box>

        <Box
          className={`flex w-full justify-between gap-2 px-2 h-[100vh] mt-1  ${isDualLineMode
            ? "max-h-[calc(100vh-300px)]"
            : "max-h-[calc(100vh-230px)]"
            } `}
        >
          <div className="flex flex-col justify-start items-center bg-[#f1f1f1] overflow-x-hidden rounded-xl w-[4%]">
            {preSettings?.map((item, index) => {
              return (
                <Button
                  className="h-[40px] mt-2 p-0"
                  key={index}
                  size="small"
                  style={{
                    fontSize: 20,
                    color: item.color,
                    backgroundColor: item.backgroundColor,
                    border:
                      item.id === selectedId
                        ? `4px solid ${item.color}`
                        : `4px solid ${item.backgroundColor}`,
                    minWidth: "40px",
                    borderRadius: "50%",
                    WebkitTextStroke: `${item.textShadowWidth} ${item.textShadowColor}`,
                  }}
                  onClick={() => handlePreSettingApply(item.id)}
                  onDoubleClick={() => handlePreSettingModal(item.id)}
                >
                  {item.id}
                </Button>
              );
            })}
          </div>

          {/* Kirtan Area */}
          <div ref={containerRef}
            className="container flex flex-col  text-center py-2 shadow overflow-y-auto overflow-x-hidden bg-[#FDF4E1]  w-1/2 rounded-3xl relative">
            {!isSearchFocused ? (
              getKirtanById() &&
              getKirtanById().content.length > 0 &&
              getKirtanById().content.map((line, index) => (
                <Stack
                  ref={selectedLine === index ? selectedLineRef : null} // Attach ref to the selected line only
                  className={`px-2 w-full flex justify-center items-center cursor-pointer border-[#ede5d4] ${selectedLine === index
                    ? isLive
                      ? 'border-2 border-solid border-red-500 bg-opacity-70 rounded-full'
                      : 'border-2 border-blue-500 bg-opacity-70 rounded-full'
                    : 'bg-inherit'
                    }`}
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={{ xs: 0, sm: 0, md: 0 }}
                  key={index}
                  onMouseEnter={() => handleRegularLineHover(index)}
                  onMouseLeave={() => handleRegularLineHover(null)}
                >
                  <div
                    className="justify-center items-center w-full grid grid-cols-3"
                    style={{ gridTemplateColumns: '1fr 35fr 1fr' }}
                  >
                    <div className={`inline ${selectedLine === index ? 'opacity-100' : 'opacity-0'}`}>
                      <i className="fa-solid fa-hand-point-right text-3xl" style={{ color: '#3170dd' }}></i>
                    </div>
                    <div
                      className="text-3xl text-center"
                      key={index + 1}
                      onClick={() => {
                        handleLineHistory(currLineIndex);
                        handleCurrLineIndex(index);
                        setUsedShortcut(null);
                        dispatch(setShortcutIndex(null));
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: line?.replace(/font-size\s*:\s*[^;]+;?/g, ''),
                        }}
                      />
                    </div>
                    <div
                      className={`text-xl font-semibold ${hoveredRegularLineIndex === index ? 'opacity-100' : 'opacity-0'
                        }`}
                    >
                      {hoveredRegularLineIndex === index && favLines && !favLines.includes(index) ? (
                        <IconButton onClick={() => handleFavLines(index)}>
                          <i className={`fa-solid fa-plus`}></i>
                        </IconButton>
                      ) : (
                        <IconButton onClick={() => handleFavLines(index)}>
                          <i className={`fa-solid fa-minus`}></i>
                        </IconButton>
                      )}
                    </div>
                  </div>
                </Stack>
              ))
            ) : (
              <>
                <Box className="w-full h-[100%] flex flex-col shadow-lg rounded-2xl p-4 overflow-auto bg-inherit gap-2 py-2 my-1">
                  <label>Kirtan Title</label>
                  <Box
                    id="title-box"
                    className="overflow-auto"
                    onScroll={handleTitleScroll}
                  >
                    {kirtanList.length > 0 &&
                      kirtanList.map((kirtan) => {
                        return (
                          <Stack
                            className={`w-full flex justify-center items-center  cursor-pointe bg-inherit no-select`}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={{ xs: 1, sm: 2, md: 4 }}
                          >
                            {
                              <div
                                className="w-full text-2xl text-center cursor-pointer hover:bg-slate-50 hover:rounded-full"
                                style={{ fontFamily: "Guj_Gopika_Two_Bold" }}
                                onClick={() => {
                                  handleSeqFetchData(kirtan, false);
                                }}
                              >
                                <p className="text-center flex justify-center items-center">
                                  <span
                                    className="text-[#0000ff]"
                                    style={{
                                      fontFamily: `Roboto, Helvetica, Arial, sans-serif`,
                                      fontSize: "15px",
                                    }}
                                  >{`#${findBookShortName(kirtan.book_id)}-${kirtan.seq_id
                                    }`}</span>
                                  -{`${kirtan.title}`}
                                </p>
                              </div>
                            }
                          </Stack>
                        );
                      })}
                    {loaderEffect && (
                      <Stack
                        className={`w-full flex justify-center items-center  cursor-pointe bg-inherit no-select`}
                        direction={{ xs: "column", sm: "row" }}
                        spacing={{ xs: 1, sm: 2, md: 4 }}
                      >
                        {
                          <div className="w-full text-2xl text-center mb-3">
                            <CircularProgress />
                          </div>
                        }
                      </Stack>
                    )}
                  </Box>
                </Box>
              </>
            )}
          </div>

          {/* VMix buttons */}
          <div className="flex flex-col justify-between items-center">
            <div className="flex flex-col justify-center items-center gap-2 ">
              <img className="h-16 bg-[#EEEEEE] rounded-full" src="/images/Kundal_Logo.png" alt="Maharaj"></img>
            </div>
            <div className="flex flex-col justify-center items-center gap-2 h-full">
              <Button className={`text-lg h-10 z-50 text-center cursor-pointer flex justify-center items-center button`} style={{ backgroundColor: isLive ? "#D89F64" : "#EEEEEE", color: isLive ? "#ffffff" : "#535353", borderRadius: "999px" }} variant="contained" onClick={() => {
                handleChange(!isLive);
              }} ><RemoveRedEyeIcon fontSize="medium" />
              </Button>
              <p>Overlay</p>
            </div>
            <div className="flex flex-col justify-center items-center gap-2 h-full">
              <Button className={`text-lg h-10 z-50 text-center cursor-pointer flex justify-center items-center button`} style={{ backgroundColor: "#EEEEEE", color: "#535353", borderRadius: "999px" }} variant="contained" onClick={() => {
                handleScreenShotClick(true);
              }} ><ScreenshotMonitorIcon fontSize="medium" />
              </Button>
              <p>ScreenShot</p>
            </div>
            {sourceMode && <div className="flex flex-col justify-center items-center gap-2 h-full">
              <Button className={`text-lg h-10 z-50 text-center cursor-pointer flex justify-center items-center button`} disabled={!sourceMode} style={{ backgroundColor: isSource ? "#D89F64" : "#EEEEEE", color: isSource ? "#ffffff" : "#535353", borderRadius: "999px" }} variant="contained" onClick={() => {
                handleVMixButtonsClick("sourceOverlay");
              }} ><VideoCameraBackIcon fontSize="medium" />
              </Button>
              <p>Source</p>
            </div>}
            {recordMode && <div className="flex flex-col justify-center items-center gap-2 h-full">
              <Button className={`text-lg h-10 z-50 text-center cursor-pointer flex justify-center items-center button `} disabled={!recordMode} style={{ backgroundColor: isRecord ? "#D89F64" : "#EEEEEE", color: isSource ? "#ffffff" : "#535353", borderRadius: "999px" }} variant="contained" onClick={() => {
                handleVMixButtonsClick("record");
              }} ><RadioButtonCheckedIcon fontSize="medium" />
              </Button>
              <p>Record</p>
            </div>}
            {streamMode && <div className="flex flex-col justify-center items-center gap-2 h-full">
              <Button className={`text-lg h-10 z-50 text-center cursor-pointer flex justify-center items-center button `} disabled={!streamMode} style={{ backgroundColor: isStream ? "#D89F64" : "#EEEEEE", color: isSource ? "#ffffff" : "#535353", borderRadius: "999px" }} variant="contained" onClick={() => {
                handleVMixButtonsClick("stream");
              }} ><CastIcon fontSize="medium" /></Button>
              <p>Stream</p>
            </div>}
            <div className="flex flex-col justify-center items-center gap-2 h-full">
              <Button className={`text-lg h-10 z-50 text-center cursor-pointer flex justify-center items-center button`} style={{ backgroundColor: multiScreenShotProcess ? "#D89F64" : "#EEEEEE", color: multiScreenShotProcess ? "#ffffff" : "#535353", borderRadius: "999px" }} variant="contained" onClick={() => {
                handleMultiScreenShot();
              }} ><ScreenshotMonitorIcon fontSize="medium" />
              </Button>
              <div className="flex flex-col justify-center items-center">
                <p>Multi</p><p>ScreenShot</p>
              </div>
            </div>
          </div>

          {/* fav line */}
          <div className="container flex items-center flex-col text-center p-2 shadow overflow-y-auto overflow-x-hidden bg-[#FDF4E1] w-1/2 rounded-3xl">
            {!isSearchFocused ? (
              <>
                <div className="w-full h-[50%]">
                  <ReactSortable
                    list={favLines}
                    setList={getUpdatedList}
                    className="w-full"
                    handle=".drag-handle"
                  >
                    {favLines?.map((line, index) => {
                      return (
                        <Stack
                          className={`w-full grid grid-cols-3 justify-between items-center  ${usedShortcut - 1 === index
                            ? isLive ? "border-2 border-solid border-red-500 bg-opacity-70 rounded-full" : "border-2 border-blue-500 bg-opacity-70 rounded-full"
                            : "bg-inherit"
                            }`}
                          style={{
                            gridTemplateColumns: "1fr 1fr 1fr",
                          }}
                          direction={{ xs: "column", sm: "row" }}
                          spacing={{ xs: 1, sm: 2, md: 4 }}
                          onMouseEnter={() => handleFavLineHover(line)}
                          onMouseLeave={() => handleFavLineHover(null)}
                          onClick={() => {
                            setUsedShortcut(index + 1);
                          }}
                          key={index}
                        >
                          <Box className="flex items-center justify-center ">
                            <Box
                              className={
                                `${index < 9 ? "opacity-100" : "opacity-0"
                                } w-20` + ` flex items-center justify-center`
                              }
                            >
                              <Button
                                sx={{
                                  height: "30px",
                                  minWidth: "30px",
                                  borderRadius: "999px",
                                }}
                                size="small"
                                variant="contained"
                              >
                                {index + 1}
                              </Button>
                            </Box>

                            <Box
                              className={`text-xl drag-handle cursor-grab bg-inherit hover:bg-inherit ${hoveredFavLineIndex === line
                                ? "opacity-100"
                                : "opacity-0"
                                }`}
                            >
                              <i className="fa-solid fa-grip-vertical text-base"></i>
                            </Box>
                          </Box>
                          <div
                            className="text-2xl text-center cursor-pointer w-full"
                            onClick={() => {
                              dispatch(setShortcutIndex(line));
                            }}
                            dangerouslySetInnerHTML={{
                              __html: getKirtanById()?.content?.[line]?.replace(
                                /font-size\s*:\s*[^;]+;?/g,
                                ""
                              ),
                            }}
                          />

                          <div
                            className={`text-xl font-semibold ${hoveredFavLineIndex === line
                              ? "opacity-100"
                              : "opacity-0"
                              }`}
                          >
                            {hoveredFavLineIndex === line &&
                              !favLines.includes(line) ? (
                              <IconButton onClick={() => handleFavLines(line)}>
                                <i className="fa-solid fa-plus"></i>
                              </IconButton>
                            ) : (
                              <IconButton onClick={() => handleFavLines(line)}>
                                <i className="fa-solid fa-minus"></i>
                              </IconButton>
                            )}
                          </div>
                        </Stack>
                      );
                    })}
                  </ReactSortable>
                </div>
                <div className="flex flex-col w-full h-[50%]">
                  <div className="mt-auto">
                    <Box className="flex flex-wrap w-full justify-center items-center gap-3">
                      {padList &&
                        padList.length > 1 &&
                        padList.map((kirtan) => {
                          return (
                            <Button
                              size="small"
                              className={`w-[35%] z-10 p-0 shadow-sm text-2xl ${kirtan.id === database_id ? "bg-white" : ""} `}
                              sx={{
                                borderRadius: "999px",
                                fontSize: "1.5rem",
                                lineHeight: "2rem",
                                color: "black",
                                fontFamily: "Guj_Gopika_Two_Bold",
                                backgroundColor: "#D8B693",
                                textTransform: "none",
                              }}
                              onClick={() => handlePadClick(kirtan.id)}
                            >
                              {/* {kirtan.title} */}
                              {`${kirtan.pad_no}`} -{" "}
                              {kirtan.title.length > 18
                                ? `${kirtan.title.slice(0, 18)}...`
                                : kirtan.title}
                            </Button>
                          );
                        })}
                    </Box>
                  </div>
                  <div className="flex gap-2 w-full justify-between items-end mt-1">
                    <Box>
                      <Button
                        className="h-[50px] z-10 p-0 shadow-lg"
                        sx={{
                          borderRadius: "999px",
                          minWidth: "50px",
                          backgroundColor: "#D89F64",
                        }}
                        onClick={handlePrevious}
                      >
                        <i className="fa-solid fa-angles-left fa-2xl text-[#FFFFFF]"></i>
                      </Button>
                    </Box>
                    <Box>
                      <Button
                        className="h-[50px] z-10 p-0 shadow-lg"
                        sx={{
                          borderRadius: "999px",
                          minWidth: "50px",
                          backgroundColor: "#D89F64",
                        }}
                        onClick={handleNext}
                      >
                        <i className="fa-solid fa-angles-right fa-2xl text-[#FFFFFF]"></i>
                      </Button>
                    </Box>
                  </div>
                </div>
              </>
            ) : (
              <>
                <Box className="w-full h-[100%] flex flex-col shadow-lg rounded-2xl p-4  bg-inherit gap-2 py-2 my-1">
                  <label className="static">Kirtan Content</label>
                  <Box
                    id="content-box"
                    className="overflow-auto"
                    onScroll={handleContentScroll}
                  >
                    {content_kirtan_list.length > 0 &&
                      content_kirtan_list.map((kirtan) => {
                        return (
                          <Stack
                            className={`w-full flex justify-center items-center  cursor-pointe bg-inherit no-select`}
                            direction={{ xs: "column", sm: "row" }}
                            spacing={{ xs: 1, sm: 2, md: 4 }}
                          >
                            {
                              <div
                                className="w-full text-2xl text-center cursor-pointer hover:bg-slate-50 hover:rounded-full"
                                style={{ fontFamily: "Guj_Gopika_Two_Bold" }}
                                onClick={() =>
                                  handleSeqFetchData(kirtan, false)
                                }
                              >
                                <p className="text-center flex justify-center items-center ">
                                  <span
                                    className="text-[#0000ff]"
                                    style={{
                                      fontFamily: `Roboto, Helvetica, Arial, sans-serif`,
                                      fontSize: "15px",
                                    }}
                                  >{`#${findBookShortName(kirtan.book_id)}-${kirtan.seq_id
                                    }`}</span>
                                  -{`${kirtan.title}`}
                                </p>
                                {/* {`${kirtan.title}`} */}
                              </div>
                            }
                          </Stack>
                        );
                      })}
                    {loaderEffect && (
                      <Stack
                        className={`w-full flex justify-center items-center  cursor-pointe bg-inherit no-select`}
                        direction={{ xs: "column", sm: "row" }}
                        spacing={{ xs: 1, sm: 2, md: 4 }}
                      >
                        {
                          <div className="w-full text-2xl text-center mb-3">
                            <CircularProgress />
                          </div>
                        }
                      </Stack>
                    )}
                  </Box>
                </Box>
              </>
            )}
          </div>
        </Box>
      </Box>
      <Box className="absolute bottom-0 w-full mt-3">
        {(
          <Box
            size="small"
            className={`stickytext-center flex justify-between items-center text-[#2497F2] px-4 font-semibold pb-1`}
          >
            {database_id && database_id !== 0 && <Box
              size="small"
              className={`text-lg z-50 text-center min-w-32`}
            >
              {`${findBookName(book_id)}-#${getKirtanById()?.seq_id}`}
            </Box>}

            <Box className={`flex flex-row justify-evenly items-center w-full`}>
              {vMixZoomButton.length > 0 && vMixZoomButton.map((item, index) => {
                return (
                  <Box
                    key={index}
                    size="small"
                    className={`text-lg z-50 text-center cursor-pointer flex justify-center items-center px-2 py-1 rounded-full`}
                    style={{
                      backgroundColor: selectedOnZoomButton.includes(index + 1) ? '#1976d2' : 'inherit',
                      color: selectedOnZoomButton.includes(index + 1) ? 'white' : 'inherit'
                    }}
                    onClick={() => {
                      handleZoomCLick(index + 1);
                    }}
                  >
                    {item.name}
                  </Box>
                );
              })}
              <Box
                key={11}
                size="small"
                className={`text-lg z-50 text-center cursor-pointer flex justify-center items-center`}
                onClick={() => navigate("/zoom")}
              >
                <img src="/images/vmixapi_icon.png" alt="V-mix" width="20" height="20" />
              </Box>
            </Box>

            <Box
              size="small"
              className={`text-lg z-50 text-center cursor-pointer flex justify-center items-center font-semibold `}
              onClick={() => {
                navigate("/manglacharan");
              }}
            >
              Manglacharan
            </Box>
          </Box>
        )}
        <KirtanLinePlate reloadFlag={reloadFlag} />
      </Box>
      <ConfirmBox
        open={showDeleteConfirm}
        handleClose={handleShowDeleteConfirm}
        handleConfirm={handleDelete}
        title={"Confirm Close Tab"}
        msg={"Are you sure you want to Close this Kirtan Tab?"}
        type={"delete"}
      />
    </div >
  );
};

export default KirtanArea;
